import { MAX_SUPPORTED_ADVERTISER_ACCOUNTS, MAX_SUPPORTED_MANAGER_ACCOUNTS } from '@flexible-reports/limits/flexible-reports-limits';
import type { TranslateMapConfig } from '@urc-ui/hooks/translate-map';
import { SINGLE_BRACKET_INTERPOLATION_OPTION } from '@urc-ui/utils/i18n-constants';

export const serverErrorMessagesMap = {
  'error.create_report_failed.header': {
    id: 'flexible_reports_banner_header_fix_issues',
    default: `Fix the following issues and submit again`
  },
  'error.update_report_failed.header': {
    id: 'flexible_reports_banner_header_fix_issues',
    default: `Fix the following issues and submit again`
  },
  'error.report_too_large.header': {
    id: 'flexible_reports_banner_header_report_too_large_temp',
    default: 'Your estimated report size is too large and report generation will fail'
  },
  'error.report_too_large.message': {
    id: 'flexible_reports_banner_content_report_too_large_temp',
    default: 'Choose a different time unit and try again. You can also request separate reports for each account or shorter report periods.'
  },
  'error.not_found.message': {
    id: 'flexible_reports_banner_content_not_found',
    default: 'This report is unavailable. Refresh the page and try again.'
  },
  'error.too_many_requests.header': {
    id: 'flexible_reports_banner_header_too_many_requests',
    default: 'Too many requests'
  },
  'error.too_many_requests.message': {
    id: 'flexible_reports_banner_content_too_many_requests',
    default: "You've requested to generate this report too many times. Refresh the page and try again."
  },
  'error.unknown.message': {
    id: 'flexible_reports_banner_content_unknown_error_temp',
    default: 'We encountered an unexpected error. Please try again or contact our support team if the issue continues.'
  },
  'error.save_failed_in_save_run.message': {
    id: 'flexible_reports_save_failed_in_save_run_message',
    default: "Sorry, we couldn't save your changes. Please try again"
  },
  'error.run_failed_in_save_run.message': {
    id: 'flexible_reports_run_failed_in_save_run_message',
    default: "Settings saved, but we couldn't run your report"
  },
  'error.max_accounts_advertisers_supported.header': {
    id: 'flexible_reports_banner_header_max_accounts_advertisers_supported',
    default: 'Account limit reached'
  },
  'error.max_accounts_advertisers_supported.message': {
    id: 'flexible_reports_banner_content_max_accounts_advertisers_supported_temp',
    default:
      'Report subscription unavailable due to account limit exceeded. Reduce your available accounts to below {x} manager accounts and {y} advertiser accounts.',
    options: {
      x: MAX_SUPPORTED_MANAGER_ACCOUNTS,
      y: MAX_SUPPORTED_ADVERTISER_ACCOUNTS,
      interpolation: SINGLE_BRACKET_INTERPOLATION_OPTION
    }
  }
} as const satisfies TranslateMapConfig;

export type ServerErrorMessageKey = keyof typeof serverErrorMessagesMap;

export const getServerErrorMessageKey = (code: string, type: 'header' | 'message'): ServerErrorMessageKey | undefined => {
  const key = `error.${code.toLowerCase()}.${type}`;
  return key in serverErrorMessagesMap ? (key as ServerErrorMessageKey) : undefined;
};
